export const UPDATE_GSM_NAME = "UPDATE_GSM_NAME";
export const UPDATE_CURRENT_TAM = "UPDATE_CURRENT_TAM";
export const UPDATE_GSM_OPTIONS = "UPDATE_GSM_OPTIONS";
export const UPDATE_DROPDOWN_LOADING = "UPDATE_DROPDOWN_LOADING";
export const UPDATE_PREFERENCES = "UPDATE_PREFERENCES";
export const UPDATE_UAT_PREFERENCES = "UPDATE_UAT_PREFERENCES";
export const UPDATE_SFG_DROPDOWN_VALUES = "UPDATE_SFG_DROPDOWN_VALUES";
export const UPDATE_PREFERENCE_DASHBOARD_TABLE_DATA = "UPDATE_PREFERENCE_DASHBOARD_TABLE_DATA";
export const UPDATE_ALL_TABLE_DATA = "UPDATE_ALL_TABLE_DATA";
export const UPDATE_START_TIME_VALUE = "UPDATE_START_TIME_VALUE";
export const UPDATE_SELECTED_SFG_ID = "UPDATE_SELECTED_SFG_ID";
export const UPDATE_DATE_EDITS_MODAL = "UPDATE_DATE_EDITS_MODAL";
export const UPDATE_SUPER_SET_ID = "UPDATE_SUPER_SET_ID";
export const UPDATE_SELECTED_START_DATE = "UPDATE_SELECTED_START_DATE";
export const UPDATE_SELECTED_END_DATE = "UPDATE_SELECTED_END_DATE";
export const UPDATE_SFG_DATA_IN_PROGRESS = "UPDATE_SFG_DATA_IN_PROGRESS";
export const UPDATE_UPDATED_START_DATE = "UPDATE_UPDATED_START_DATE";
export const UPDATE_UPDATED_END_DATE = "UPDATE_UPDATED_END_DATE";
export const UPDATE_TAM_START_DATE = "UPDATE_TAM_START_DATE";
export const UPDATE_TAM_END_DATE = "UPDATE_TAM_END_DATE";
export const UPDATE_SFG_ID_LIST = "UPDATE_SFG_ID_LIST";
export const UPDATE_SFG_DROPDOWN_LIST = "UPDATE_SFG_DROPDOWN_LIST";
export const UPDATE_SFG_ID_NAME_MAPPING = "UPDATE_SFG_ID_NAME_MAPPING";
export const UPDATE_TRENDS_VIEW_SEARCH_REQUEST = "UPDATE_TRENDS_VIEW_SEARCH_REQUEST";
export const UPDATE_TRENDS_VIEW_DATE_RANGE = "UPDATE_TRENDS_VIEW_DATE_RANGE";
export const UPDATE_SELECTED_LOGICAL_GROUP = "UPDATE_SELECTED_LOGICAL_GROUP";
export const UPDATE_LOGICAL_GROUP_DROPDOWN_VALUES= "UPDATE_LOGICAL_GROUP_DROPDOWN_VALUES";
export const UPDATE_LOGICAL_GROUP_LIST = "UPDATE_LOGICAL_GROUP_LIST";
export const UPDATE_SELECTED_IPN = "UPDATE_SELECTED_IPN";
export const UPDATE_IPN_DROPDOWN_VALUES = "UPDATE_IPN_DROPDOWN_VALUES";
export const UPDATE_SELECTED_MONTH = "UPDATE_SELECTED_MONTH";
export const UPDATE_HISTORICAL_QTY_CONSUMPTION_TABLE_DATA = "UPDATE_HISTORICAL_QTY_CONSUMPTION_TABLE_DATA";
export const UPDATE_HISTORICAL_QTY_CONSUMPTION_SEARCH_REQUEST = "UPDATE_HISTORICAL_QTY_CONSUMPTION_SEARCH_REQUEST";
export const UPDATE_HISTORICAL_QTY_CONSUMPTION_PREFERENCES = "UPDATE_HISTORICAL_QTY_CONSUMPTION_PREFERENCES";
export const UPDATE_COMPUTED_MONTHS_OPTIONS = "UPDATE_COMPUTED_MONTHS_OPTIONS";